export class Emitter {
    constructor() {
        this.handlers = new Set();
    }
    emit(data) {
        for (const fn of this.handlers) {
            fn(data);
        }
    }
    onEmit(fn) {
        this.handlers.add(fn);
        return () => this.unsubscribe(fn);
    }
    unsubscribe(fn) {
        this.handlers.delete(fn);
    }
}
